'use client';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
// import 'animate.css/animate.compat.css';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Customer = () => {
    return (
        <ScrollAnimation
            animateIn="fadeIn"
            offset={100}
            delay={500}
            animateOnce={true}
            duration={1}
        >
            <div className="customer">
                <FullWrapper className="customer">
                    <CommonSmallText className="customer__text">
                        Наша команда — генеральный подрядчик по digital-маркетингу Технопарка
                        «Сколково», в том числе сообщества AdventureLand.
                    </CommonSmallText>
                    <CommonSmallText className="customer__text">
                        Adventureland — точка входа в венчурную часть экосистемы «Сколково»,
                        крупнейшее комьюнити стартапов/инвесторов в России в самом большом
                        технопарке Европы.
                    </CommonSmallText>
                </FullWrapper>
            </div>
        </ScrollAnimation>
    );
};

Customer.propTypes = {};

export default Customer;
